

























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import ActionShowButton from '@/modules/shared/components/shared/table/action/ActionShowButton.vue'
import { AdminPredefinedAnswerService } from '@/modules/predefined-answer/services/admin-predefined-answer.service'
import { PredefinedAnswerCollectionModel } from '@/modules/predefined-answer/models/predefined-answer-collection.model'
import AdminPredefinedAnswerUpdateDialog
  from '@/modules/predefined-answer/components/admin/AdminPredefinedAnswerUpdateDialog.vue'

@Component({
  components: {
    BaseButton,
    ActionShowButton
  }
})
export default class AdminPredefinedAnswerActions extends Vue {

  constructor(
    private readonly service: AdminPredefinedAnswerService
  ) {
    super()
  }

  @Prop() predefinedAnswer!: PredefinedAnswerCollectionModel
  private answer: PredefinedAnswerCollectionModel = null

  editDialog() {
    this.answer = { ...this.predefinedAnswer }
    this.$q.dialog({
      component: AdminPredefinedAnswerUpdateDialog,
      predefinedAnswer: this.answer
    })
  }

  destroy() {
    this.service.destroy(this.predefinedAnswer.id)
  }
}

